import { Config } from '../../config'

export const daiggerConfig: Config = {
  partner: 'daigger',
  catalog: 'partner',
  displayName: 'Daigger Scientific',
  accentColor: '#000000',
  host: 'daiggerlabchairs.com',
  extraAttributes: {
    hideProductPageButton: true,
  },
}
